export const TABLE_SETTINGS_KEY = 'addRelatedDocsModalTableSettings';
